import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import "./EagleFeedback.css";
import VideoCollector from '../components/VideoCollector';

const TurboFeedback = () => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = "Turbo Feedback";
        fetchDriverFeedback();
    }, []);

    const [selectedPositiveVideos, setSelectedPositiveVideos] = useState([]);
    const [selectedPositiveValues, setSelectedPositiveValues] = useState([]);
    const [feedbackPositiveText, setFeedbackPositiveText] = useState('');
    const [selectedNegativeVideos, setSelectedNegativeVideos] = useState([]);
    const [selectedNegativeValues, setSelectedNegativeValues] = useState([]);
    const [feedbackNegativeText, setFeedbackNegativeText] = useState('');
    const [consentGiven, setConsentGiven] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const fetchDriverFeedback = async () => {
        setIsSubmitted(false);
        try {
            const endpoint = '/form/turboFeedback';
            const response = await fetch(endpoint, {
                method: 'GET',
            });

            if (response.status === 204) {
                console.log('No submissions available.');
                setIsSubmitted(false);
                return;
            }

            if (!response.ok) {
                console.error('Failed to fetch driver feedback:', response.statusText);
                setIsSubmitted(false);
                return;
            }

            const data = await response.json();
            setSelectedPositiveVideos(data.selectedPositiveVideos || []);
            setSelectedPositiveValues(data.selectedPositiveValues || []);
            setFeedbackPositiveText(data.feedbackPositiveText || '');
            setSelectedNegativeVideos(data.selectedNegativeVideos || []);
            setSelectedNegativeValues(data.selectedNegativeValues || []);
            setFeedbackNegativeText(data.feedbackNegativeText || '');
            setConsentGiven(data.consentGiven || false);
            setIsSubmitted(true);
        } catch (error) {
            console.error('Error fetching driver feedback:', error);
            setIsSubmitted(false);
        }
    };

    const handlePositiveCheckboxChange = (e) => {
        const updatedValues = e.target.checked
            ? [...selectedPositiveValues, e.target.value]
            : selectedPositiveValues.filter(val => val !== e.target.value);

        setSelectedPositiveValues(updatedValues);
    };

    const handleNegativeCheckboxChange = (e) => {
        const updatedValues = e.target.checked
            ? [...selectedNegativeValues, e.target.value]
            : selectedNegativeValues.filter(val => val !== e.target.value);

        setSelectedNegativeValues(updatedValues);
    };

    const handlePositiveVideoStateChange = (updatedVideos) => {
        setSelectedPositiveVideos(updatedVideos);
    };

    const handleNegativeVideoStateChange = (updatedVideos) => {
        setSelectedNegativeVideos(updatedVideos);
    };

    const handleConsentChange = (event) => {
        setConsentGiven(event.target.checked);
    };

    const handlePositiveFeedbackChange = (e) => {
        setFeedbackPositiveText(e.target.value);
    };

    const handleNegativeFeedbackChange = (e) => {
        setFeedbackNegativeText(e.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (selectedPositiveValues.length === 0) {
            alert('Please select checkbox before submitting your feedback.');
            return;
        }

        //if (selectedPositiveVideos.length === 0) {
        //    alert('Please upload a video before submitting your feedback.');
        //    return;
        //}

        if (feedbackPositiveText.trim() === '') {
            alert('Please provide your feedback in the text area.');
            return;
        }

        if (!consentGiven) {
            alert('Please agree to the privacy notice before submitting');
            return;
        }

        console.log('Feedback submitted with videos:', selectedPositiveVideos);
        console.log('Selected options:', selectedPositiveValues);
        console.log('Text feedback:', feedbackPositiveText);
        try {
            const response = await fetch('/form/submissionTurboFeedback', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    selectedPositiveVideos,
                    selectedPositiveValues,
                    feedbackPositiveText,
                    selectedNegativeVideos,
                    selectedNegativeValues,
                    feedbackNegativeText,
                    consentGiven,
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                alert(`Error: ${errorData}`);
                return;
            }
            alert('Thank you for your feedback!');
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } catch (error) {
            console.error('Error submitting feedback:', error);
            alert('An error occurred while submitting the feedback.');
        }
    };

    if (isSubmitted) {
        return (
            <div className="submission-success">
                <h1>Thank You!</h1>
                <p>Your feedback has been successfully submitted.</p>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-eagle-feedback">
                <h1>Driver-Partner experience update: Share your Turbo feedback</h1>
                <label className="label-submission">
                    Feedback
                </label>
                <br />
                <p>{t('TurboFeedback.P.Thankyou')}</p>
                <p>{t('TurboFeedback.P.Instruction')}</p>
                <div className="checkbox-group">
                    <h3>{t('TurboFeedback.H3.Question1')}<span className="mandatory-message">*</span></h3>
                    <label>
                        <input
                            type="checkbox"
                            value="Turbo Cashback - Get a fixed percentage of cashback for every trip"
                            onChange={handlePositiveCheckboxChange}
                        />
                        {t('TurboFeedback.P.QO1')}
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            value="Prority Registration - Better access to sign up for desired Streaks slots"
                            onChange={handlePositiveCheckboxChange}
                        />
                        {t('TurboFeedback.P.QO2')}
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            value="Preferred Area- More frequently get trips heading to my preferred area"
                            onChange={handlePositiveCheckboxChange}
                        />
                        {t('TurboFeedback.P.QO3')}
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            value="Manual Mode - Control which trips I receive when I need to (with conditions)"
                            onChange={handlePositiveCheckboxChange}
                        />
                        {t('TurboFeedback.P.QO4')}
                    </label>
                </div>

                <h3>{t('TurboFeedback.H3.P.Video.Instruction')} {/*<span className="mandatory-message">*</span>*/}</h3>
                <span>{t('TurboFeedback.P.P.Video.Instruction.1')}</span>
                <VideoCollector
                    selectedVideosState={selectedPositiveVideos}
                    changeVideoState={handlePositiveVideoStateChange}
                    maxVideoCount={1}
                />

                <h3>{t('TurboFeedback.H3.P.Text.Instruction')} <span className="mandatory-message">*</span></h3>
                <span>{t('TurboFeedback.P.P.Text.Instruction.1')}</span>
                <textarea
                    rows="4"
                    cols="50"
                    placeholder="Share your feedback here..."
                    value={feedbackPositiveText}
                    onChange={handlePositiveFeedbackChange}
                    required
                ></textarea>

                <div className="checkbox-group">
                    <h3>{t('TurboFeedback.N.H3.Instruction')}</h3>
                    <label>
                        <input
                            type="checkbox"
                            value="Need to be online for a period before starting to earn incentives"
                            onChange={handleNegativeCheckboxChange}
                        />
                        {t('TurboFeedback.N.QO1')}
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            value="It's difficult to stay online long enough to unlock benefits like Streaks priority"
                            onChange={handleNegativeCheckboxChange}
                        />
                        {t('TurboFeedback.N.QO2')}
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            value="Feeling forced to go to locations I don't prefer"
                            onChange={handleNegativeCheckboxChange}
                        />
                        {t('TurboFeedback.N.QO3')}
                    </label>
                    <label>
                        <input
                            type="checkbox"
                            value="Worried about receiving strikes for rejecting trips or not following guidance"
                            onChange={handleNegativeCheckboxChange}
                        />
                        {t('TurboFeedback.N.QO4')}
                    </label>
                </div>

                <h3>{t('TurboFeedback.H3.N.Video.Instruction')}</h3>
                <span>{t('TurboFeedback.N.P.Video.Instruction.1')}</span>
                <VideoCollector
                    selectedVideosState={selectedNegativeVideos}
                    changeVideoState={handleNegativeVideoStateChange}
                    maxVideoCount={1}
                />

                <h3>{t('TurboFeedback.H3.N.Text.Instruction')}</h3>
                <span>{t('TurboFeedback.H3.N.Text.Instruction.1')}</span>
                <textarea
                    rows="4"
                    cols="50"
                    placeholder="Share your feedback here..."
                    value={feedbackNegativeText}
                    onChange={handleNegativeFeedbackChange}
                ></textarea>
            </div>
            <div className="checkbox-group checkbox-consent">
                <input
                    type="checkbox"
                    id="consentCheckbox"
                    checked={consentGiven}
                    onChange={handleConsentChange}
                />
                <label htmlFor="consentCheckbox">
                    {t('TurboFeedback.Label.Consent')}
                    <a href="https://www.grab.com/my/terms-policies/privacy-notice/" target="_blank" rel="noopener noreferrer">{t('EagleFeedback.Href.Consent')}</a>.
                </label>
                <span className="mandatory-message">*</span>
            </div>
            <button type="submit" className="submit-button">Submit Feedback</button>
        </form>
    );
}

export default TurboFeedback;